import { useState } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { H2RButton, H2RInput, H2RSelect, cuesApi, socketActions } from '../../imports'
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";


function parseHTML(htmlContent) {
  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlContent, 'text/html');
  let scriptTag = doc.querySelector('script[name="graphics-data-definition"]');

  if (scriptTag) {
    let scriptContent = scriptTag.innerHTML;
    return scriptContent
  } else {
      return JSON.stringify({})
  }
}

async function readFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsText(file);
  });
}


export const GraphicEditor = ({ cue, onUpdate, media }) => {
  const [importing, setImporting] = useState(false)
  const [error, setError] = useState(null)
	let { projectId } = useParams()

  const throwError = (error) => {
    setImporting(false)
    setError(error)
  }

	const fileUpload = (e, type = 'html') => {
    console.log('will import')
    setError(null)
		e.preventDefault()
		let array = Array.from(e.target.files)

		array.forEach(async (file) => {
			setImporting(true)
			const formData = new FormData()
			formData.append("file", file)

      const { data } = await cuesApi.importFile(projectId, formData)
      console.log('did import')

      if(!data.fileData) return throwError('This file could not be imported.')
      
      const fileContent = await readFile(file);
      const templateDefinition = parseHTML(fileContent);
      
      // if(!templateDefinition) return throwError('We could not find any template data in this file.')
      console.log('[templateDefinition]', templateDefinition);
      // if(!templateDefinition) return throwError('We could not find any template data in this file.')
      
      let parsed = ''
      
      try {
        parsed = JSON.parse(templateDefinition)
        console.log('[templateDefinition]', JSON.parse(templateDefinition));
      } catch (error) {
        return throwError('Could not parse template file.')
      }
      onUpdate({ 
        html: data.fileData, // Set the path and data of the .html file
        template: parsed, // Set up the template definitions
        status: 'ready', // Ensure the newly imported graphic is offair
        name: parsed.title || ''
      })

      e.target.value = ''
			return setImporting(false)
		})
	}

	return (
		<>
      <H2RButton
        text="How this works"
        size="small"
        colour="light"
        icon={faExternalLink}
        onClick={() => {
          return socketActions.visitExternal(
            "https://h2r.graphics/docs/graphics/custom-html/"
          );
        }}
      />
      <label className="h-16 mx-2 my-2 flex flex-col justify-center items-center text-center cursor-pointer bg-gray-900 border-2 border-gray-800 rounded hover:border-gray-700 hover:bg-gray-800">
        {cue.html && <p>{cue.html.originalname}</p>}
        <span className="text-xs text-gray-500 font-semibold">
          {cue.html ? 'Replace' : 'Add'} HTML file
        </span>
        <input
          className="opacity-0 h-0"
          type="file"
          name="file"
          accept=".html"
          onChange={fileUpload}
        />
      </label>

      {cue.template?.properties && Object.entries(cue.template.properties).map(([key, templateItem]) => {
        const elementId = key
        const elementTitle = key
        const defaultValue = templateItem.default
        const elementType = templateItem.gddType
        if(elementType === 'single-line' || elementType === 'multi-line') {
          return (
            <H2RInput
              key={`${cue.html.originalname}_${elementId}`}
              label={elementId || elementTitle}
              value={cue.data?.[elementId] || defaultValue}
              onChange={(value) => {
                onUpdate({
                  data: {
                    ...cue.data,
                    [elementId]: value
                  }
                })
              }}
            />
          )
        } else if (elementType === 'file-path/image-path') {
          return (
            <H2RSelect
              selected={cue.data?.[elementId] || ''}
              label={elementId || elementTitle}
              options={
                media.length === 0
                  ? [
                      {
                        label: "Add images in the Media tab",
                        value: ``,
                        disabled: true,
                      },
                    ]
                  : [
                      ...media
                        .filter((item) => item.mimetype.includes("image"))
                        .filter((item) => !item.partOf)
                        .sort((a, b) => {
                          if(a.originalname.toUpperCase() < b.originalname.toUpperCase()) { return -1; }
                          if(a.originalname.toUpperCase() > b.originalname.toUpperCase()) { return 1; }
                          return 0;
                        })
                        .map((item) => {
                          return {
                            label: item.originalname,
                            value: item.filename,
                          };
                        }),
                    ]
              }
              onChange={(value) => {
                return onUpdate({
                  data: {
                    ...cue.data,
                    [elementId]: value
                  }
                })
              }}
            />
              )
            }
        return null
      })}
      {error && <p className="text-red-500 text-sm"><strong>Import error</strong>: {error}</p>}
    </>
	)
}

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
        `}
		>
			<span className="font-semibold">
				{cue.name || cue.html?.originalname || 'Custom HTML'}
			</span>
		</div>
	)
}
